import { SpreadSchema } from '@lilith-arcana-os/domain';
import { ANNUAL_WHEEL_13_LAYOUT } from '../layouts/annual-wheel-13.js';
import { BALANCED_3_LAYOUT } from '../layouts/balanced-3.js';
import { CELTIC_CROSS_10_LAYOUT } from '../layouts/celtic-cross-10.js';
import { CROSSED_3_LAYOUT } from '../layouts/crossed-3.js';
import { CUSTOM_CIRCLE_12_LAYOUT, CUSTOM_GRID_6_LAYOUT, CUSTOM_GRID_9_LAYOUT } from '../layouts/custom-grid.js';
import { HORSESHOE_7_LAYOUT } from '../layouts/horseshoe-7.js';
import { LILITH_MIRROR_9_LAYOUT } from '../layouts/lilith-mirror-9.js';
import { LINE_5_LAYOUT } from '../layouts/line-5.js';
import { LINEAR_3_LAYOUT } from '../layouts/linear-3.js';
import { SINGLE_1_LAYOUT } from '../layouts/single-1.js';
import { TREE_OF_LIFE_10_LAYOUT } from '../layouts/tree-of-life-10.js';
import { POSITION_ROLE_MAP } from '../roles/position-roles.js';
const ALL_LAYOUT_TEMPLATES_INTERNAL = [
    SINGLE_1_LAYOUT,
    LINEAR_3_LAYOUT,
    BALANCED_3_LAYOUT,
    CROSSED_3_LAYOUT,
    LINE_5_LAYOUT,
    HORSESHOE_7_LAYOUT,
    CELTIC_CROSS_10_LAYOUT,
    ANNUAL_WHEEL_13_LAYOUT,
    LILITH_MIRROR_9_LAYOUT,
    TREE_OF_LIFE_10_LAYOUT,
    CUSTOM_GRID_6_LAYOUT,
    CUSTOM_GRID_9_LAYOUT,
    CUSTOM_CIRCLE_12_LAYOUT,
];
const uniqueValues = (values) => Array.from(new Set(values));
export const getLayoutTemplateOrThrow = (layoutId) => {
    const layout = ALL_LAYOUT_TEMPLATES_INTERNAL.find((candidate) => candidate.id === layoutId);
    if (!layout) {
        throw new Error(`Unknown spread layout template: ${layoutId}.`);
    }
    return layout;
};
export function createSpreadDefinition(config) {
    const layout = getLayoutTemplateOrThrow(config.layout_id);
    const portrait = layout.variants.find((variant) => variant.id === 'portrait') ?? layout.variants[0];
    if (!portrait) {
        throw new Error(`Layout ${layout.id} must expose at least one variant.`);
    }
    if (portrait.points.length !== config.position_specs.length) {
        throw new Error(`Spread ${config.slug} expects ${config.position_specs.length} positions but layout ${layout.id} exposes ${portrait.points.length}.`);
    }
    const spread = SpreadSchema.parse({
        id: config.id,
        name: config.name,
        slug: config.slug,
        category: config.category,
        cards: config.position_specs.length,
        positions: config.position_specs.map((spec, index) => {
            const role = POSITION_ROLE_MAP[spec.role_id];
            const point = portrait.points[index];
            if (!role || !point) {
                throw new Error(`Spread ${config.slug} cannot resolve role or layout point at index ${index}.`);
            }
            return {
                index,
                name: spec.name ?? role.label,
                description: spec.description ?? role.description,
                sephirah_correspondence: spec.sephirah_correspondence ?? null,
                qliphah_correspondence: spec.qliphah_correspondence ?? null,
                element_affinity: spec.element_affinity ?? null,
                x: point.x,
                y: point.y,
                z: point.z,
            };
        }),
        is_lilith: config.is_lilith,
        description: config.description,
        ritual_note: config.ritual_note,
        opening_invocation: config.opening_invocation,
        closing_words: config.closing_words,
        difficulty: config.difficulty,
        tree_of_life_mapping: config.tree_of_life_mapping,
    });
    return {
        spread,
        family: config.family,
        intent: uniqueValues(config.intent),
        semantic_tags: uniqueValues(config.semantic_tags),
        layout_id: config.layout_id,
        position_role_ids: config.position_specs.map((spec) => spec.role_id),
        keywords: uniqueValues(config.keywords),
        recommended_for_questions: uniqueValues(config.recommended_for_questions),
        contraindications: uniqueValues(config.contraindications),
        focus_mode_ids: uniqueValues(config.focus_mode_ids),
        ritual_intensity: config.ritual_intensity,
        position_overlay_notes: config.position_specs.map((spec) => spec.overlay_narrative_note ?? null),
    };
}
//# sourceMappingURL=builders.js.map